import { Spin } from "antd";
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { YearlyRevenueIcon } from "../../icons";
import styles from "./styles.module.scss";

export const YearlyRevenue = ({
  height,
  revenuYearlyGraph,
  loading: revenuYearlyGraphLoading,
}) => {
  const chartLegends = [
    {
      label: "Total Sold",
      color: "#006AB3",
    },
    {
      label: "Total Profit",
      color: "#94C800",
    },
  ];

  // const CustomYAxisTick = (props) => {
  //   const { x, y, payload } = props;
  //   return (
  //     <g transform={`translate(${x},${y})`}>
  //       <text x={5} fill="#C2C6CE" textAnchor="end" style={{ fontSize: "8px" }}>
  //         {`${payload.value}%`}
  //       </text>
  //     </g>
  //   );
  // };

  return (
    <Spin spinning={revenuYearlyGraphLoading}>
      <div className={styles.yearlyRevenueContainer}>
        {/* {loading} */}
        <div className={styles.header}>
          <div className={styles.headingWithIcon}>
            <div className={styles.circleWithIcon}>
              <YearlyRevenueIcon />
            </div>
            <div className={styles.title}>Revenue of this year</div>
          </div>
          <div className={styles.chartLegends}>
            {chartLegends?.map((item) => (
              <div className={styles.chartLegend} key={item.label}>
                <span style={{ backgroundColor: item.color }} />
                {item.label}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.chart}>
          <ResponsiveContainer width="100%" height={height - 75}>
            <AreaChart
              width={500}
              data={revenuYearlyGraph}
              margin={{
                top: 10,
                right: 30,
                left: 0,
                bottom: 0,
              }}
            >
              <defs>
                <linearGradient id="uv" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#006AB3" stopOpacity={0.8} />
                  <stop offset="95%" stopColor="#006AB3" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="pv" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#94C800" stopOpacity={0.8} />
                  <stop offset="95%" stopColor="#94C800" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="1 1" vertical={false} />
              <XAxis
                dataKey="month"
                // axisLine={false}
                strokeDasharray="1 1"
                tickLine={false}
              />
              <YAxis axisLine={false} tickLine={false} />
              <Tooltip content={<CustomTooltip />} />
              <Area
                type="monotone"
                dataKey="sold"
                stackId="sold"
                stroke="#006AB3"
                fill="url(#uv)"
              />
              <Area
                type="monotone"
                dataKey="total_amount"
                stackId="total_amount"
                stroke="#94C800"
                fill="url(#pv)"
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    </Spin>
  );
};

function CustomTooltip({ payload, label, active }) {
  if (active) {
    return (
      <div className={styles["custom-tooltip"]}>
        <p className={styles["label"]}>{label}</p>

        {payload.map((item) => {
          return (
            <div className={styles["item"]} style={{ "--color": item.color }}>
              <span className={styles["circle"]}></span>
              <span className={styles["name"]}>
                Total Profit {item?.month}:
              </span>
              <span className={styles["value"]}>{item?.value}</span>
            </div>
          );
        })}
      </div>
    );
  }

  return null;
}
